import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-files-folder-thunder-icon',
  templateUrl: './files-folder-thunder.component.html'
})
export class FilesFolderThunderComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
